<template>
	<dropdown class='npa-discovered-violations-dropdown form-control height-control' :class='names == "н/д" ? "warrant-field-error" : ""' v-model='val' @input='open' :disabled='disabled' :text='names'>
		 <li role="separator" class="divider"></li>
		 <table class='npa-violation-table'>
		 	<thead>
		 		<th></th>
		 		<th>Нарушение пунктов пост. Пра-ва 1158</th>
		 	</thead>
		 	<tbody>
		 		<tr v-for='i in items'>
		 			<td class='npa-violation-td-checkbox'><checkbox type='info' class='npa-violation-checkbox' v-model='i.checked' @input='check(i.id, i.name_short, i.checked)'></checkbox></td>
		 			<td style="text-align: left !important; padding-left: 5px;">{{i.name}}</td>
		 		</tr>
		 	</tbody>
		 </table>
	</dropdown>
</template>

<script>
	import { dropdown, checkbox } from 'vue-strap'
	import { EventBus } from '../../../lib/EventBus'
	import {DB} from './../../../constants'

	const DISCOVERED_VIOLATIONS = 'get_discovered_violations.php'
	//const WARRANT_INFO = 'get_warrant_info.php'

	export default {
		name: 'discoveredViolations',
		data () {
			return {
				items: [],
				names: 'н/д',
				names_obj: {},
				val: false,
				sel: false
			}
		},
		props: {
			disabled: false,
			ids: '',
			index: null
		},
		components: {
			dropdown,
			checkbox
		},
		methods: {
			check(id,name,value) {
				if (value)
					this.names_obj[id] = name
				else
					this.names_obj[id] = null

				let text = ''
				let ids = []
				for (let key in this.names_obj) {
					if (typeof this.names_obj[key] != 'undefined' && this.names_obj[key] != null) {
						text += this.names_obj[key] + ', '
						ids.push(key)
					}
				}

				text = text.slice(0, -2)

				if (text.length > 12)
					this.names = text.slice(0,12) + '...'
				else
					this.names = text

				if(!this.names.length)
					this.names = 'н/д'

				EventBus.$emit('warrant_discovered_violations', {index: this.$props.index, ids})
			},
			open (show) {
				if (show) {
					let _ids = ''
					if(this.ids)
						for (let i = 0; i < this.ids.length; i++) {
							_ids += this.ids[i]
						}

					_ids = _ids.slice(1,-1).split(',')
					for (let i = 0; i < _ids.length; i++) {
						for (let j = 0; j < this.items.length; j++) {
							if (_ids[i] == this.items[j].id) {
								this.items[j].checked = true
							}
						}
					}
				}
				
			},
			fill (ids) {
				fetch(DB + DISCOVERED_VIOLATIONS,{
					credentials: 'include'
				})
				.then(res => res.json())
				.then(res => {
					if (res) {
						let arr = res.map(r => {
							return {
								id: r.id,
								name_short: r.name_short,
								name: r.name,
								checked: false
							}
						})

						if (typeof ids != 'undefined') {
							let text = ''
							for (let i = 0; i < ids.length; i++) {
								for (let j = 0; j < arr.length; j++){
									if (ids[i] == arr[j].id) {
										text += arr[j].name_short + ', '
									}
								}
							}

							text = text.slice(0, -2)

							if (text.length > 12)
								this.names = text.slice(0,12) + '...'
							else
								this.names = text
						}

						this.items = arr
					}
					else {
						this.items = []
					}

					EventBus.$emit('warrant_discovered_violations', {index: this.$props.index, ids})
				})
				.catch(err => console.log(err))
			}
		},
		created () {
			/*fetch(DB + WARRANT_INFO + '?id=' + this.$route.params.id, {
				credentials: 'include'
			})
			.then(res => res.json())
			.then(res => {
				return res[0].f_92
			})
			.then(ids => {
				if (ids) {
					ids = ids.slice(1,-1).split(',')
					this.fill(ids)
				}
				else {
					this.fill()
				}
			})*/
			//console.warn(this.$props.ids)
			let ids = this.$props.ids ? (this.$props.ids.length > 2 ? this.$props.ids.slice(1,-1).split(',') : undefined) : undefined
			//console.warn(ids)
			this.fill(ids)
		},
		beforeDestroy() {
			EventBus.$emit('warrant_discovered_violations_update')
		}
	}

</script>

<style>
.npa-discovered-violations-dropdown.warrant-field-error button {
		background-color: #ffd5d5 !important;
	}

.npa-discovered-violations-dropdown .dropdown-menu {
	left: unset !important;
	right: 0;
}

.npa-discovered-violations-dropdown .caret {
	position: absolute;
    right: 6px;
    top: 40%;
}

.npa-discovered-violations-dropdown button {
	font-size: 12px;
	height: 23px;
	border-radius: 0;
}

.npa-discovered-violations-dropdown {
	width: 100%;
	padding: 0 !important;
	margin: 0;
    border: none;
}

.npa-discovered-violations-dropdown > button.dropdown-toggle {
	font-weight: normal;
	/*font-size: 12px;*/
}

.npa-discovered-violations-dropdown > ul.dropdown-menu {
	min-width: 550px !important;
	top: auto !important;
	bottom: 100% !important;
	margin-bottom: 2px !important;
	max-height: 500px;
	overflow-x: auto;
	font-size: 85%;
}

/*.npa-violation-dropdown > button > span.caret {
	float: right;
}
*/
.npa-violation-table {
	width: 100%;
	height:100%;
}

.npa-violation-table tr {
	height: 30px;
}

.npa-violation-table td.npa-violation-td-checkbox {
	width: 30px;
	min-width: 30px;
}

.npa-violation-checkbox {
	margin-top: 0px !important;
	margin-bottom: 18px !important;
	margin-left: 7px !important;
}

/*ul.dropdown-menu {
	padding-left: 10px;
	padding-right: 10px;
	max-height: 500px;
	min-width: 200px;
	overflow-y: auto;
}*/
</style>


// WEBPACK FOOTER //
// discoveredViolations.vue?e41ad5b6